import React from 'react';

export default function PermissionMatrix({ groups, value, onChange }) {
  const has = (p) => value.includes(p);

  const toggle = (g, a) => {
    const p = `${g}.${a}`;
    if (has(p)) {
      // برداشتن view، بقیه‌ی پرمیشن‌های همان بخش را هم برمی‌دارد
      onChange(value.filter((x) => x !== p && !(a === 'view' && x.startsWith(`${g}.`))));
    } else {
      const next = [...value, p];
      if (a !== 'view' && !next.includes(`${g}.view`)) next.push(`${g}.view`);
      onChange(next);
    }
  };

  const toggleGroup = (g) => {
    const all = g.actions.map((a) => `${g.key}.${a.key}`);
    onChange(
      all.every(has)
        ? value.filter((x) => !all.includes(x))
        : [...new Set([...value, ...all])]
    );
  };

  return (
    <div className="pm">
      {groups.map((g) => (
        <div className="pm-row" key={g.key}>
          <button type="button" className="pm-group" onClick={() => toggleGroup(g)}>
            {g.label}
          </button>
          <div className="pm-acts">
            {g.actions.map((a) => (
              <label className="pm-check" key={a.key}>
                <input
                  type="checkbox"
                  checked={has(`${g.key}.${a.key}`)}
                  onChange={() => toggle(g.key, a.key)}
                />
                <span>{a.label}</span>
              </label>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}